export const CHECK_FOR_AD_BLOCKER = 'CHECK_FOR_AD_BLOCKER';
export const UPDATE_AD_BLOCK_STATUS = 'UPDATE_AD_BLOCK_STATUS';
export const FRESHDESK_LINK = 'https://copilotsupport.freshdesk.com/support/home';
export const NEW_FRESHDESK_TICKET_LINK = 'https://copilotsupport.freshdesk.com/support/tickets/new';
export const BULK_CREATE_HELP_CENTER_LINK = 'https://copilotsupport.freshdesk.com/support/solutions/articles/47001275409-bulk-create-strategies';
